import React from 'react';

import { Button } from 'components/Button';
import { Flex } from 'components/Flex';
import { H4 } from 'components/Text';

type Props = {
  onClick: () => void;
  toggled: boolean;
  index: number;
  title: string;
};

export function AccordionBlockTitle({ onClick, toggled, index, title }: Props) {
  return (
    <Button
      onClick={onClick}
      aria-controls={`accordionSection${index}`}
      aria-expanded={toggled}
      width="100%"
    >
      <H4 m="0" py="30px">
        <Flex
          justifyContent="space-between"
          width="100%"
          alignItems="center"
          textAlign="left"
        >
          <span>{title}</span>
          <span>{toggled ? '-' : '+'}</span>
        </Flex>
      </H4>
    </Button>
  );
}
